"use client";

import { useCallback } from "react";
import { useAppSelector } from "@/store/hooks";

interface MainProduct {
  productID?: string | number;
  qty: string | number;
}

interface AddOnCartItem {
  pid: string | number;
  qty: string | number;
  from: 0 | 1;
}

const toNumber = (value: string | number | undefined | null) => Number(value || 0);

const isSameProduct = (left?: string | number, right?: string | number) =>
  !!left && !!right && toNumber(left) === toNumber(right);

export default function useAddOnCartItems(mainProduct?: MainProduct) {
  const availableCartItems = useAppSelector(
    (state) => state.cartList.data.list.available
  );

  return useCallback(
    (addOnProductID: string | number): AddOnCartItem[] => {
      const addOnCartItem: AddOnCartItem = {
        pid: addOnProductID,
        qty: 1,
        from: 1,
      };

      if (!mainProduct?.productID) return [addOnCartItem];

      const mainCartItem = availableCartItems.find(
        (item) =>
          isSameProduct(item.productID, mainProduct.productID) &&
          toNumber(item.fromZone) !== 1
      );

      if (mainCartItem && toNumber(mainCartItem.appSelectStatus) === 1) {
        return [addOnCartItem];
      }

      return [
        {
          pid: mainProduct.productID,
          qty: mainProduct.qty,
          from: 0,
        },
        addOnCartItem,
      ];
    },
    [availableCartItems, mainProduct]
  );
}
